import { useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, TAG, Tags } from '@/core';

export const useTags = ({ page, limit }: { page: number; limit: number }) => {
  const fullUrl = `${ADMIN_API_URL_SUBPATH}/${TAG}`;

  const useTagsSearch = (search: string) =>
    useQuery<Tags>({
      queryKey: ['tagsSearch', search],
      queryFn: async () => {
        if (search === '') return [];
        const response = await axiosInstance.get(`${fullUrl}/search`, { params: { name: search } });
        return response.data;
      },
    });

  const useTagsQuery = useQuery<Tags>({
    queryKey: ['tags', page, limit],
    queryFn: () => axiosInstance.get(fullUrl, { params: { page, limit } }).then((res) => res.data),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: true,
    enabled: true,
  });

  return {
    useTagsQuery,
    useTagsSearch,
  };
};
